import React from "react";
import { FIRMS, VENDORS, VENDOR_NOTES } from "../../consts/tables";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { getData, manageData } from "../../requests/CRUD";
import { updateVendor } from "../../requests/vendors";
import request from 'arcdynamic-request';
import VendorInfo from "./VendorInfo";
import VendorCompanyInfo from "./VendorCompanyInfo";
import VendorNotesModal from "./VendorNotesModal";
import VendorLoanCriteria, { isLender, LOAN_CRITERIA_COLUMNS } from "./VendorLoanCriteria";
import LinkedFirm, { LinkedFirmEdits } from "../LinkedFirm";
import { priceToString } from "../CRUDProperty/CRUDProperty";

const limit = 1000;

const priceProps = [
  "LOAN_AMOUNT_MIN",
  "LOAN_AMOUNT_MAX",
];

const dateProps = [
  "LAST_MODIFIED"
];

function convertDataToForm(dbData) {
  const data = {...dbData};

  priceProps
      .filter((key) => data[key])
      .forEach((key) => {
          const num = Number(data[key]);
          if (num === num) {
              // !isNaN
              data[key] = num.toLocaleString();
          }
      });

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateISOtoUS(data[key]);
          if (str !== false)
              data[key] = str;
      });

  return data;
}

function convertFormToData(formData) {
  const data = {...formData};

  priceProps.forEach((key) => {
      const num = priceToString(data[key]);
      if (num !== false)
          data[key] = num;
  });

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateUStoISO(data[key]);
          if (str !== false)
              data[key] = str;
      });

  return data;
}

function getVendorName(data) {
  return data.NAME || [data.FIRST_NAME, data.LAST_NAME].filter(Boolean).join(' ');
}

function getVendorCompanyName(data) {
  return data.COMPANY_NAME || data.FIRM_NAME || '';
}

async function createCrmVendor(data) {
  const res = await fetch('/api/crm/create-lead', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      type: 'vendor',
      vendorType: data.VENDOR_TYPE || '',
      vendorSubtype: data.VENDOR_SUBTYPE || '',
      name: getVendorName(data),
      firstName: data.FIRST_NAME || '',
      lastName: data.LAST_NAME || '',
      phone: data.PHONE || '',
      workPhone: data.WORK_PHONE || '',
      email: data.EMAIL_ID || '',
      firmId: data.FIRM_ID || null,
      companyName: getVendorCompanyName(data),
      companyAddress: data.COMPANY_ADDRESS || '',
      companyCity: data.COMPANY_CITY || '',
      companyState: data.COMPANY_STATE || '',
      companyZip: data.COMPANY_ZIP || '',
      website: data.WEBSITE || '',
      notes: data.NOTES || '',
    }),
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || !json || !json.success) {
    throw new Error((json && (json.message || json.error)) || 'Failed to create vendor in CRM');
  }
  return json;
}

export default class CRUDVendor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists:false,
      loggedInUserEmail:null,
      errorTabs: [],
      users:[],
      currentTab: 0,
      viewMode: this.props.edit || false,
      notes: [],
      pendingNotes: [],
      showNotesModal: false,
      firm: null,
      firmOriginal: null,
    };

    this.firmEdits = new LinkedFirmEdits(this, 'FIRM_ID');

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.saveData = this.saveData.bind(this);
    this.fetchNotes = this.fetchNotes.bind(this);
    this.handleAddPendingNote = this.handleAddPendingNote.bind(this);
    this.handleEditPendingNote = this.handleEditPendingNote.bind(this);
    this.handleDeletePendingNote = this.handleDeletePendingNote.bind(this);
  }

  fetchNotes() {
    const vendorId = this.props.params.id
      || (this.state.data && this.state.data.ARCIMEDES_ROW_ID);

    if (!vendorId) {
      this.setState({ notes: [] });
      return;
    }

    getData({
      tableCode: VENDOR_NOTES,
      columns: [
        "ARCIMEDES_ROW_ID",
        "VENDOR_ID",
        "NOTE_TEXT",
        "DATE_CREATED",
        "CREATED_BY",
        "LAST_MODIFIED_DATE",
        "LAST_MODIFIED_BY",
        "DELETED",
      ],
      options: {
        filter: [
          { text: '', code: 'DELETED', type: 'null' },
          { text: vendorId, code: "VENDOR_ID", type: "exact" },
        ],
        filterType: 'and',
      },
    })
      .then((res) => {
        const list = (res && res.data !== undefined) ? res.data : [];
        // Newest first. The generic GetData action ignores `order`, so sort here;
        // a higher ARCIMEDES_ROW_ID is the more recently added note.
        list.sort((a, b) => Number(b.ARCIMEDES_ROW_ID) - Number(a.ARCIMEDES_ROW_ID));
        this.setState({ notes: list });
      })
      .catch(() => this.setState({ notes: [] }));
  }

  handleAddPendingNote(noteText) {
    const text = (noteText || "").trim();
    if (!text) return;
    const now = new Date().toISOString();
    const userName = this.state.loggedInUserEmail || "User";
    this.setState(prevState => ({
      pendingNotes: [{
        PENDING_ID: `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        NOTE_TEXT: text,
        DATE_CREATED: now,
        CREATED_BY: userName,
        LAST_MODIFIED_DATE: now,
        LAST_MODIFIED_BY: userName,
        DELETED: 0,
      }, ...prevState.pendingNotes],
    }));
  }

  handleEditPendingNote(pendingId, noteText) {
    const text = (noteText || "").trim();
    if (!pendingId || !text) return;
    this.setState(prevState => ({
      pendingNotes: prevState.pendingNotes.map(note => (
        note.PENDING_ID === pendingId
          ? {
            ...note,
            NOTE_TEXT: text,
            LAST_MODIFIED_DATE: new Date().toISOString(),
            LAST_MODIFIED_BY: this.state.loggedInUserEmail || "User",
          }
          : note
      )),
    }));
  }

  handleDeletePendingNote(pendingId) {
    if (!pendingId) return;
    this.setState(prevState => ({
      pendingNotes: prevState.pendingNotes.filter(note => note.PENDING_ID !== pendingId),
    }));
  }

  /**
   * Notes typed before the vendor existed have no VENDOR_ID; write them once the
   * new id is known. Resolves true only when they are safely persisted — the
   * caller keeps them in state otherwise so nothing typed is lost.
   */
  flushPendingNotes(vendorId) {
    const pending = this.state.pendingNotes;
    if (!vendorId || !pending || !pending.length) return Promise.resolve(true);

    const rows = pending
      .slice()
      .reverse()
      .map(({ PENDING_ID, ...note }) => ({ ...note, VENDOR_ID: Number(vendorId) }));

    return manageData({ tableCode: VENDOR_NOTES, data: rows })
      .then((res) => {
        if (res && res.success) {
          this.setState({ pendingNotes: [] });
          return true;
        }
        return false;
      })
      .catch(() => false);
  }

  /**
   * Creating a vendor stores only what its Kore lead carries, so a new lender's
   * criteria are saved once the id is known. Resolves with the error, if any.
   */
  saveNewLoanCriteria(vendorId, data) {
    const criteria = {};
    LOAN_CRITERIA_COLUMNS
      .filter(key => data[key] !== undefined && data[key] !== null && data[key] !== '')
      .forEach(key => { criteria[key] = data[key]; });

    if (!isLender(data) || !Object.keys(criteria).length) return Promise.resolve(null);

    return updateVendor(vendorId, criteria)
      .then(() => null)
      .catch(err => `The vendor was saved, but its loan criteria were not: ${err.message} Press Edit, then Save to try again.`);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
      this.fetchNotes();
    }
  }

  componentDidMount() {    
    this.setState({loggedInUserEmail: this.props.userData.email});
    this.fetch(this.props.params.id);
    this.fetchNotes();
  }

  componentDidUpdate() {
    this.firmEdits.follow();
  }
 
  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });
    if (id === undefined) {
      this.setState({
          data: {},
          original: {}
      });
      return;
    }
    
    getData({
      tableCode: VENDORS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {       
        this.setState({          
          data: convertDataToForm(res.data[0]),
          original: { ...convertDataToForm(res.data[0])},
          error: null,
      })
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }
  
  fetchUserData(offset) {
    const options = {
      limit: {
        count: limit,
        offset: offset * limit,
      },
      column: [
        'ARCIMEDES_ROW_ID',
        'VENDOR_TYPE',
        'FIRST_NAME',
        'LAST_NAME',
        'PHONE',
        'WORK_PHONE',
        'EMAIL_ID',
        'COMPANY_NAME',
        'COMPANY_ADDRESS',
        'COMPANY_CITY',
        'COMPANY_STATE',
        'COMPANY_ZIP',
        'WEBSITE',
        'NOTES',
        'DELETED',
      ]
    };
    getData({
      tableCode: VENDORS,
      options: options,
    }).then(res => {
      this.setState(prevState => {
        const users = prevState.users.concat(res.data);
        return {
          users,
        };
      });
      if (res.data.length >= limit) {
        this.fetchUserData(++offset);
      } else {
        const isExists = this.state.users.filter(u => (this.state.data.ARCIMEDES_ROW_ID != undefined && this.state.data.ARCIMEDES_ROW_ID != null) ? u.ARCIMEDES_ROW_ID != this.state.data.ARCIMEDES_ROW_ID: true ).find((e) => {       
          return (            
            (e.FIRST_NAME != null && e.FIRST_NAME.toLowerCase()) == (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
            (e.LAST_NAME != null && e.LAST_NAME.toLowerCase()) == (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase()) &&
            (e.PHONE == this.state.data.PHONE)
          )
        });
        this.setState({
          isExists: !!isExists,
        })
        if (isExists) {
          return
        }
        else {
          this.setState({ viewMode: true }, () => this.saveData());
        }
      }
    });
  }
  async handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode)this.setState({ viewMode: false });

    if (this.state.isBusy || this.state.viewMode === true) return;

    this.setState({ viewMode: true }, () => this.saveData());

  }

  populateVendorCompanyFromFirm(data, firm) {
    const firmName = firm && firm.NAME ? firm.NAME.replace(/^\s+–\s*/, '') : '';
    data.FIRM_NAME = firmName;
    data.COMPANY_NAME = firmName;
    data.COMPANY_ADDRESS = (firm && firm.ADDRESS) || '';
    data.COMPANY_CITY = (firm && firm.CITY) || '';
    data.COMPANY_STATE = (firm && firm.STATE) || '';
    data.COMPANY_ZIP = (firm && firm.ZIP) || '';
    data.WEBSITE = (firm && firm.WEBSITE) || '';
    this.setState({ data });
  }

  handleChangeDropdown(query, queryType, x, key, typeKey, selectedOption) {
    const data = {...this.state.data};
    data[key] = query[key];

    if (key === 'VENDOR_TYPE' && data.VENDOR_TYPE !== this.state.data.VENDOR_TYPE) {
      data.VENDOR_SUBTYPE = null;
    }

    if (key !== 'FIRM_ID') {
      this.setState({ data });
      return;
    }

    if (!data.FIRM_ID) {
      this.populateVendorCompanyFromFirm(data, null);
      return;
    }

    if (selectedOption && selectedOption.ADDRESS !== undefined) {
      this.populateVendorCompanyFromFirm(data, selectedOption);
      return;
    }

    getData({
      tableCode: FIRMS,
      options: {
        limit: { count: 1, offset: 0 },
        filter: [
          {
            code: 'ARCIMEDES_ROW_ID',
            text: String(data.FIRM_ID),
            type: 'equal',
          },
        ],
        filterType: 'and',
      },
    }).then((res) => {
      const firm = res && res.success && Array.isArray(res.data) && res.data.length
        ? res.data[0]
        : selectedOption;
      this.populateVendorCompanyFromFirm({ ...this.state.data, FIRM_ID: data.FIRM_ID }, firm);
    });
  }
  handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value
      }),
      updateSeller:true
    });
  }
  
  saveData() {
    if (this.state.isBusy) return;

    return this.firmEdits.saveThen(() => this.saveVendor());
  }

  saveVendor() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    const dataToSave = convertFormToData(this.state.data);
    const original = this.state.original || {};
    // Delete and Undelete stay on Arc; only an edit is carried on to the Kore lead.
    const isEdit = Boolean(dataToSave.ARCIMEDES_ROW_ID)
      && (dataToSave.DELETED || null) === (original.DELETED || null);
    const savePromise = (!this.props.edit && !dataToSave.LEAD_ID)
      ? createCrmVendor(dataToSave).then((created) => {
        const savedData = {
          ...dataToSave,
          ARCIMEDES_ROW_ID: created.arcRowId,
          LEAD_ID: created.leadId ? String(created.leadId) : dataToSave.LEAD_ID,
          FIRM_ID: created.firmId || dataToSave.FIRM_ID,
        };
        return { success: true, data: [savedData], existing: Boolean(created.existing) };
      })
      : isEdit
        ? updateVendor(dataToSave.ARCIMEDES_ROW_ID, dataToSave).then((saved) => ({ success: true, data: [saved] }))
        : manageData({
          tableCode: VENDORS,
          data: [dataToSave],
        });

    return savePromise.then((res) => {
        if (res && res.success) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
              data: convertDataToForm(res.data[0]),
              original: convertDataToForm(res.data[0]),
            },
            () => {
              const savedId = res.data[0].ARCIMEDES_ROW_ID;

              if (!this.props.edit) {
                // Anything typed before the vendor existed is written against the
                // new id first; a failed write holds the redirect so the queue is
                // not discarded.
                // A vendor that already existed is opened as it is, like the server
                // leaves it, so the form's criteria do not overwrite its own.
                const criteriaSave = res.existing ? Promise.resolve(null) : this.saveNewLoanCriteria(savedId, dataToSave);
                criteriaSave.then((criteriaError) => {
                  if (criteriaError) {
                    this.setState({ error: criteriaError });
                    return;
                  }
                  this.flushPendingNotes(savedId).then((notesSaved) => {
                    if (!notesSaved) {
                      this.setState({ error: 'The vendor was saved, but its notes could not be. Reopen Notes and add them again.' });
                      return;
                    }
                    browserHistory.push({ pathname: `/vendor/${savedId}` });
                  });
                });
                return;
              }

              this.fetchNotes();
            }
          );
          window.scrollTo(0, 0);
        } else {
            this.setState({
              isBusy: null,
              data: null,
              original: null,
              error: res && res.message ? res.message : "Unspecified error",            
            });
        }
      }).catch((err) => {
        this.setState({
          isBusy: null,
          error: err && err.message ? err.message : "Unspecified error",
        });
      });
  }
  
  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <React.Fragment>
      <CRUD
        tabsData={[
          {
            name: "VENDOR",
            renderedComponent: (
              <VendorInfo
                data={data}
                isExists={this.state.isExists}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
                notes={[...this.state.pendingNotes, ...this.state.notes]}
                onShowNotes={() => this.setState({ showNotesModal: true })}
              />

            ),
          },
          {
            name: "FIRM",
            // A vendor with no firm keeps the company address typed on it.
            renderedComponent: data && data.FIRM_ID ? (
                <LinkedFirm
                    firm={this.state.firm}
                    viewMode={this.state.viewMode}
                    deleted={data.DELETED === "1"}
                    onChange={this.firmEdits.change}
                />
            ) : (
                <VendorCompanyInfo
                    data={data}
                    handleChangeInput={this.handleChangeInput}
                    handleChangeDropdown={this.handleChangeDropdown}
                    viewMode={this.state.viewMode}
                    deleted={data && data.DELETED === "1"}
                />
            ),
          },
          // Hidden, not cleared, when the type changes: a slip of the dropdown loses nothing.
          ...(isLender(data) ? [{
            name: "LOAN CRITERIA",
            renderedComponent: (
              <VendorLoanCriteria
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data.DELETED === "1"}
              />
            ),
          }] : []),
        ]}
        backLink={`${arc.path.base}vendors`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        onCancel={this.firmEdits.discard}
        type="Vendors"
        backName="VENDORS"
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
        forceActions={editsEverySummitRecord(getCurrentAccess())}
      />
      <VendorNotesModal
        show={this.state.showNotesModal}
        onClose={() => this.setState({ showNotesModal: false })}
        notes={[...this.state.pendingNotes, ...this.state.notes]}
        vendorId={this.props.params.id || (data && data.ARCIMEDES_ROW_ID)}
        currentUser={this.state.loggedInUserEmail}
        fetchNotes={this.fetchNotes}
        onAddPendingNote={this.handleAddPendingNote}
        onEditPendingNote={this.handleEditPendingNote}
        onDeletePendingNote={this.handleDeletePendingNote}
      />
      </React.Fragment>
    );
  }
}
